export default {
  title: 'Informe Firmado / Activo',
  column_groups: {
    current_period: 'Período actual',
  },
  fields: {
    name: 'Nombre',
    area: 'Área',
    signed: 'Firmado',
    live: 'Activo',
    going_live: 'Activándose',
    going_live_avg: 'Promedio de activación',
    churned: 'Dado de baja',
    not_live: 'No activo',
    live_ratio: 'Ratio activo',
    avg_mrr: 'MRR medio',
  },
  manager_status_filters: {
    active: 'Activo',
    inactive: 'Inactivo',
    all: 'Todos',
  },
  status_filters: {
    all: 'Todos',
    not_live: 'No activo',
  },
  drawer: {
    title: '{{column}} — {{managerName}}',
    subtitle_one: '{{count}} restaurante',
    subtitle_other: '{{count}} restaurantes',
    empty: 'No se encontraron restaurantes.',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos, actualice la página',
  },
};
